import type { ChainIndentity } from "./queries"
import type { InjectedAccount } from "@polkadot/extension-inject/types"

import * as R from 'ramda'

import trimAddress from './trimAddress'

export default function formatDisplayName(identity: ChainIndentity, account?: InjectedAccount | string, fallback: string = '') {
  if (identity.displayName) {
    return identity.displayName
  }
  if (account) {
    if (R.is(String, account)) {
      return trimAddress(account)
    }
    if (account.name) {
      return account.name
    }
    return trimAddress(account.address)
  }
  return fallback
}
